// Claves centralizadas para React Query
// Usar estas constantes en TODOS los useQuery, useInfiniteQuery e invalidateQueries
// para garantizar consistencia entre el admin y las páginas públicas

export const QUERY_KEYS = {
  // Noticias
  noticias:        ['noticias'],
  noticiasPreview: ['noticias-preview'],
  noticiaDetalle:  (slug) => ['noticia', slug],

  // Galería
  galeria:         ['galeria'],
  galeriaPreview:  ['galeria-preview'],

  // Equipo
  equipo:           ['equipo'],
  equipoEmpleadoMes: ['equipo', 'empleado-mes'],

  // Carrusel del Hero
  carousel:        ['carousel'],

  // Convenios
  convenios:       ['convenios'],

  // Reseñas
  resenas:         ['resenas'],

  // Admin stats
  dashboardStats:  ['dashboard-stats'],
  dashboardRecent: ['dashboard-recent'],

  // Usuarios
  usuarios:        ['usuarios'],

  // Niveles
  niveles:         ['niveles'],

  // CINFOP
  cinfop:          ['cinfop'],
};
